import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing account data information
 */
const create = () => {
    // Create BaseApi instance with provided options
    const api = BaseApi.create({});

    const getConfig = () => api.getAnonymous(ApiPaths.GET_CONFIGURATION);
        
    // Return back a collection of functions
    return {
        getConfig
    }
}

// let's return back our create method as the default.
export default {
    create
}